import Layout from '@/layout'

const qrcodeRouter = {
    path: '/qrcode',
    component: Layout,
    meta: {
        title: '二维码生成器'
    },
    children: [
        {
            path: '',
            name: 'Qrcode',
            component: () => import('@/views/qrcode/index')
        }
    ]
}

export default qrcodeRouter